<template>
    <EChart :options="chartData" card :header="$t('purchasedItemsInTime')" :loading="request.getLoading()" type="time" />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'AverageQuantityInTime',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData2,
            };
        },
        computed: {
            data() {
                return this.parentComponent.data2;
            },
            chartData() {
                if (!this.data?.length) return { series: [] };

                const groupedData = {};

                this.data.forEach(item => {
                    const date = new Date(item.createdAt.substring(0, 10)).getTime();
                    if (!groupedData[date]) {
                        groupedData[date] = 0;
                    }
                    groupedData[date] += item.quantity;
                });

                // Sortujemy daty chronologicznie
                const sortedDates = Object.keys(groupedData).sort();
                const quantities = sortedDates.map(date => groupedData[date]);

                return {
                    xAxis: {
                        data: sortedDates,
                    },
                    series: [
                        {
                            name: this.$t('quantityPieces'),
                            type: 'bar',
                            data: quantities,
                        },
                    ],
                };
            },
        },
    };
</script>
